// Async boundary do Module Federation: o entry não pode importar nada que
// consuma shared (react, react-dom) sincronamente, senão o loadShareSync
// dispara antes do runtime inicializar (RUNTIME-006). O import() dinâmico
// permite ao webpack aguardar a inicialização do share scope.
import('./main');
